import * as React from "react";
function XlIcon() {
    return React.createElement("path", { d: "M20.0002 26.9144L10.5771 17.4914L12.0686 16L20.0002 23.9487L27.9318 16.0171L29.4232 17.5085L20.0002 26.9144Z", fill: "currentColor" });
}
export default XlIcon;
//# sourceMappingURL=Xl.js.map